import { render, staticRenderFns } from "./TaskAddDialog.vue?vue&type=template&id=5f84356b"
import script from "./TaskAddDialog.vue?vue&type=script&lang=js"
export * from "./TaskAddDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports